/**
 * The product's name, in one place.
 *
 * Until 2026-09-13 the login screen said „AccessoryShop" — the FIRST shop's
 * name, which every later shop (SAMGORI, MINIMAX, the household-goods one)
 * read as somebody else's brand. The domain is martepos.com; the product is
 * MartePOS. Three files cannot import and carry the same string with a
 * pointer here: index.html, the manifest in vite.config.ts, src/sw.js.
 *
 * What is NOT the brand and must not follow it: the Worker name
 * `accessoryshop-pos` (every installed till's origin), the localStorage keys
 * (`accessoryshop-theme`, `sb-accessoryshop-recovery`) and the service-worker
 * cache names. Renaming any of those is a new app to every device that has
 * one — see the note at the top of wrangler.jsonc.
 */
export const BRAND = 'MartePOS'
export const BRAND_URL = 'https://martepos.com'
export const BRAND_DESCRIPTION = 'სალარო, საწყობი და ბუღალტერია მცირე მაღაზიისთვის'

/** Where a shop writes to us — Cloudflare Email Routing forwards it to the
 *  platform owner's inbox (2026-09-25). The terms (10.3), the privacy policy
 *  (Art. 8), the deletion page (Google Play), the deletion mails' reply-to.
 *  Changing it changes the legal texts: bump TERMS_VERSION with it. */
export const SUPPORT_EMAIL = 'support@martepos.com'

/** 1.69 — the guests' table menu lives on its own host (spec §5.3): a sticker's QR opens
 *  `${MENU_ORIGIN}/t?k=<token>`. The POS never boots there (the inline guard in index.html — keep equal) and the
 *  Worker answers only /api/table there (lib/guest-api.ts `hostAllows`). The domain is attached at release, on the
 *  owner's word. */
export const MENU_HOST = 'menu.martepos.com'
export const MENU_ORIGIN = `https://${MENU_HOST}`
